<!-- keep this div -->
<div>
    <cmps-teamscall-auth [showLogin]="false">
        <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
            <ng-container *ngIf="!state?.hasPendingData">
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    (click)="_onReturnClick()"
                >
                    <cmps-icon
                        class="cmps-cdk-fill-blue-100"
                        svgIcon="arrow-left"
                    ></cmps-icon>
                </button>
                <input
                    type="text"
                    class="flex-grow-1 topic cmps-cdk-font-bold cmps-cdk-color-blue-100 cmps-cdk-pr-0dot5"
                    [ngModel]="state?.chat?.topic"
                    [ngModelOptions]="{ updateOn: 'blur' }"
                    (ngModelChange)="_onTopicChange($event)"
                />
                <button
                    cmpsIconButton
                    [disabled]="!data?.canCreateNotes"
                    [cmpsTooltipTrigger]="
                        (data?.canCreateNotes
                            ? _i18n._11132_CREATE_COACHING_NOTES_FROM_CHAT_CONVERSATION
                            : _i18n._11138_COMMITMENT_MUST_BE_ACTIVE_OR_DRAFT
                        ) | translate
                    "
                    trigger="hover"
                    (click)="_onAddNotesClick()"
                >
                    <cmps-icon svgIcon="note-plus-outline"></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="
                        _i18n._11136_EXPAND_WINDOW | translate
                    "
                    (click)="_onExpandClick()"
                >
                    <cmps-icon svgIcon="arrow-expand"></cmps-icon>
                </button>
            </ng-container>
        </div>
        <div class="focus cmps-cdk-my-0dot5">{{ state.behaviour }};</div>
        <div class="focus cmps-cdk-my-0dot5">{{ state.subBehaviour }}</div>
    </cmps-teamscall-auth>
</div>
<cmps-teamscall-auth [showLogin]="false">
    <cmps-wait-status *ngIf="state?.hasPendingData"></cmps-wait-status>
</cmps-teamscall-auth>
<div class="body">
    <cmps-teamscall-auth
        [class.cmps-cdk-d-block]="authRef.hasValidToken !== true"
        [class.cmps-cdk-text-center]="authRef.hasValidToken !== true"
        [class.cmps-cdk-d-flex]="authRef.hasValidToken === true"
        [class.cmps-cdk-flex-direction-col-rev]="authRef.hasValidToken === true"
        (hasValidTokenChange)="_onHasValidTokenChange($event)"
        #authRef
    >
        <ng-container *ngIf="!state?.hasPendingData">
            <ng-container *ngFor="let bubble of state.conversation">
                <div
                    *ngIf="bubble.isUser"
                    class="row chat-message-user reveal"
                >
                    <div class="message-user">
                        <div>
                            {{
                                bubble.startTime
                                    | cmpsDate: 'MMMM dd, YYYY h:mm a'
                            }}
                        </div>
                        <div class="row user-row">
                            <div class="hide">
                                <button
                                    class="cmps-icon-button--no-bg"
                                    cmpsIconButton
                                    [cmpsMenuTrigger]="userMenu"
                                    placement="bottom-right"
                                >
                                    <cmps-icon
                                        svgIcon="dots-vertical"
                                    ></cmps-icon>
                                </button>
                                <cmps-menu #userMenu="cmpsMenu">
                                    <button
                                        class="cmps-button--no-bg cmps-button--left"
                                        cmpsButton
                                        (click)="_onCopyClick(bubble.message)"
                                    >
                                        <span cmpsButtonLabel>{{
                                            _i18n._11130_COPY_MESSAGE
                                                | translate
                                        }}</span>
                                    </button>
                                    <button
                                        class="cmps-button--no-bg cmps-button--left"
                                        cmpsButton
                                        (click)="_onDeleteClick(bubble)"
                                    >
                                        <span cmpsButtonLabel>{{
                                            _i18n._11131_DELETE_MESSAGE
                                                | translate
                                        }}</span>
                                    </button>
                                </cmps-menu>
                            </div>
                            <div class="bubble-user">
                                <div class="text">{{ bubble.message }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="avatar">
                        <img
                            class="avatar-img"
                            src="{{ bubble.avatar }}"
                            *ngIf="bubble.avatar"
                        />
                        <div *ngIf="!bubble.avatar">
                            <cmps-icon
                                svgIcon="account-circle"
                                class="avatar-placeholder ml-2"
                            ></cmps-icon>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="!bubble.isUser"
                    class="row chat-message reveal"
                >
                    <div class="avatar">
                        <img
                            class="avatar-img"
                            src="{{ bubble.avatar }}"
                            *ngIf="bubble.avatar"
                        />
                        <div *ngIf="!bubble.avatar">
                            <cmps-icon
                                svgIcon="account-circle"
                                class="avatar-placeholder mr-4"
                            ></cmps-icon>
                        </div>
                    </div>
                    <div class="message">
                        <div class="row">
                            <div>
                                <div class="name">
                                    {{ bubble.msftDisplayName }}
                                </div>
                                {{
                                    bubble.startTime
                                        | cmpsDate: 'MMMM dd, YYYY h:mm a'
                                }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="bubble">
                                <div class="text">{{ bubble.message }}</div>
                            </div>
                            <div class="hide">
                                <button
                                    class="cmps-icon-button--no-bg"
                                    cmpsIconButton
                                    [cmpsMenuTrigger]="menu"
                                    placement="bottom-left"
                                >
                                    <cmps-icon
                                        svgIcon="dots-vertical"
                                    ></cmps-icon>
                                </button>
                                <cmps-menu #menu="cmpsMenu">
                                    <button
                                        class="cmps-button--no-bg cmps-button--left"
                                        cmpsButton
                                        (click)="_onCopyClick(bubble.message)"
                                    >
                                        <span cmpsButtonLabel>{{
                                            _i18n._11130_COPY_MESSAGE
                                                | translate
                                        }}</span>
                                    </button>
                                </cmps-menu>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </cmps-teamscall-auth>
</div>
<div class="footer">
    <cmps-teamscall-auth [showLogin]="false">
        <form
            #f="ngForm"
            (ngSubmit)="_onSubmit(f)"
            *ngIf="!state?.hasPendingData"
        >
            <div class="row input-row">
                <textarea
                    class="col input"
                    type="text"
                    name="message"
                    autocomplete="off"
                    [placeholder]="_i18n._11036_ENTER_YOUR_TEXT | translate"
                    [(ngModel)]="_inputMessage"
                    (keyup)="_onInputChange($event)"
                    (keydown.enter)="$event.preventDefault(); _onSubmit(f)"
                    (keydown.shift.enter)="
                        $event.preventDefault(); _onShiftEnterClick()
                    "
                ></textarea>
                <button
                    class="emoji"
                    type="button"
                    (click)="_isEmojiPickerVisible = !_isEmojiPickerVisible"
                >
                    <cmps-icon svgIcon="emoticon-outline"></cmps-icon>
                </button>
                <br />
                <emoji-mart
                    class="emoji-mart emoji-picker"
                    *ngIf="_isEmojiPickerVisible"
                    (emojiSelect)="_onEmojiSelect($event)"
                    (appClickOutside)="_onOutsideClick()"
                    [title]="_i18n._11134_SELECT_YOUR_EMOJI | translate"
                    set="google"
                    totalFrequentLines="1"
                ></emoji-mart>
                <button
                    class="send"
                    type="submit"
                >
                    <cmps-icon svgIcon="send"></cmps-icon>
                </button>
            </div>
        </form>
    </cmps-teamscall-auth>
</div>
